import React from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { ManageSchedule } from '@components/templates';

export function ManageSchedulePage() {
    const { uuid } = useParams();
    const { t } = useTranslation();

    const translations = {
        title: t('manage-schedule-component.metatags.title'),
        description: t('manage-schedule-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.mySchedule.replace(':uuid', `${uuid}`),
        index: false,
    });

    return <ManageSchedule />;
}
